import { IApplicationState } from '../../../../../../../../types/types';
import { connect } from 'react-redux';
import { IWebhooksSectionHOCProps } from './types';
import { IWebhooksSectionEvents, IWebhooksSectionFields } from '../../components/WebhooksSection/types';
import { WebhooksSection } from '../../components/WebhooksSection/WebhooksSection';
import { getBoardUserMetaWebhooks } from '../../../../../../../../store/model/board/selectors/getBoardUserMetaWebhooks';
import { onSave } from './events/onSave';
import { onDidMount } from './events/onDidMount';
import { getPanelReadonly } from '../../../../selectors/getPanelReadonly';
import { isKanbanchiUser } from '../../../../../../../../store/model/authUser/selectors/isKanbanchiUser';
import { onDelete } from './events/onDelete';

const mapStateToProps = (
    state: IApplicationState,
    { boardId }: IWebhooksSectionHOCProps,
): IWebhooksSectionFields => {
    return {
        isReadonly: getPanelReadonly(state, boardId),
        isShow: isKanbanchiUser(state),
        webhook: getBoardUserMetaWebhooks(state, boardId),
    }
};

const mapDispatchToProps = (
    dispatch: any,
    { boardId }: IWebhooksSectionHOCProps,
): IWebhooksSectionEvents => {
    return {
        onDelete: () => dispatch(onDelete(boardId)),
        onDidMount: () => dispatch(onDidMount(boardId)),
        onSave: (webhook) => dispatch(onSave(boardId, webhook)),
    }
};

export const WebhooksSectionHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(WebhooksSection);
